// import React from "react";
// import icons from "../../../icons.config";

// function LogOutPopup({ setShowLogoutPopup }) { // ✅ Accept setShowLogoutPopup as a prop
//   return (
//     <div className="fixed inset-0 flex items-center justify-center z-20 bg-black bg-opacity-50">
//       <div className="bg-tertiary lg:w-[40%] rounded-lg shadow-lg px-6 pb-8 z-30">
//         {/* Close Button */}
//         <div className="flex justify-end relative top-8 cursor-pointer">
//           <button
//             className="text-xl text-gray-600"
//             onClick={() => setShowLogoutPopup(false)} // ✅ Close popup
//           >
//             <img src={icons.close} alt="close icon" />
//           </button>
//         </div>

//         <h2 className="text-2xl font-normal font-outfit mb-4 text-center">
//           LOG OUT
//         </h2>
//         <hr className="mb-6 text-secondary" />

//         <div className="flex justify-center mb-10">
//           <p className="text-primary1 font-poppins text-xl font-light">
//             Are you sure you want to log out?
//           </p>
//         </div>

//         {/* Buttons */}
//         <div className="flex justify-around mb-3 gap-4">
//           <button
//             onClick={() => setShowLogoutPopup(false)} // ✅ Close on cancel
//             className="w-[50%] py-2 bg-hcolor border text-tertiary hover:bg-tertiary hover:text-hcolor hover:border-hcolor cursor-pointer"
//           >
//             CANCEL
//           </button>

//           <button
//             onClick={() => {
//               alert("Logged out!"); // Replace with actual logout logic
//               setShowLogoutPopup(false); // ✅ Close on logout
//             }}
//             className="w-[50%] py-2 bg-tertiary border border-hcolor text-hcolor hover:bg-hcolor hover:text-tertiary cursor-pointer"
//           >
//             LOG OUT
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default LogOutPopup;

import React, { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../store/authSlice";
import icons from "../../../icons.config";

function LogOutPopup({ setShowLogoutPopup }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    // Remove token consistent with Login component
    localStorage.removeItem("authToken"); // Changed from "token" to "authToken"
    localStorage.removeItem("user");

    dispatch(logout()); // Dispatch logout action
    navigate("/login"); // Changed to /login for consistency
    setShowLogoutPopup(false); // Close the popup
  };

  useEffect(() => {
    document.body.classList.add("overflow-hidden"); // Fixed from "hidden"
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowLogoutPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowLogoutPopup]);

  return (
    <div className="fixed inset-0 flex items-center justify-center z-20">
      <div ref={popupRef} className="bg-tertiary lg:w-[40%] rounded-lg shadow-lg px-6 pb-8 z-30">
        {/* Close Button */}
        <div className="flex justify-end relative top-8 cursor-pointer">
          <button
            className="text-xl text-gray-600"
            onClick={() => setShowLogoutPopup(false)}
          >
            <img src={icons.close} alt="close icon" />
          </button>
        </div>

        <h2 className="text-2xl font-normal font-outfit mb-4 text-center">
          LOG OUT
        </h2>
        <hr className="mb-6 text-secondary" />

        <div className="flex justify-center mb-10">
          <p className="text-primary1 font-poppins text-xl font-light">
            Are you sure you want to log out?
          </p>
        </div>

        {/* Buttons */}
        <div className="flex justify-around mb-3 gap-4">
          <button
            onClick={() => setShowLogoutPopup(false)}
            className="w-[50%] py-2 bg-hcolor border text-tertiary hover:bg-tertiary hover:text-hcolor hover:border-hcolor cursor-pointer"
          >
            CANCEL
          </button>

          <button
            onClick={handleLogout}
            className="w-[50%] py-2 bg-tertiary border border-hcolor text-hcolor hover:bg-hcolor hover:text-tertiary cursor-pointer"
          >
            LOG OUT
          </button>
        </div>
      </div>
    </div>
  );
}

export default LogOutPopup;